import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

const Item = ({ value, text }) => (
  <option value={value}>{text}</option>
);

const SelectInput = (props) => {
  const {
    name,
    groupName,
    inputId,
    selected,
    onChange,
    disabled,
    options,
    className,
    locked,
  } = props;

  return (
    <div className={classnames('select-input-wrapper', { 'select-input-wrapper--locked': locked })}>
      <select
        name={`${groupName}[${name}]`}
        className={classnames('custom-select', className, { 'locked-select': locked })}
        value={selected}
        onChange={onChange}
        disabled={disabled}
        id={inputId}>
        {options.map((item) => <Item key={item.value} {...item} />)}
      </select>
      {locked && (
        <img src={Spree.image_assets.lock_icon} className="select-lock-icon" alt="Lock" />
      )}
    </div>
  );
};

SelectInput.defaultProps = {
  name: '',
  groupName: 'parameters',
  selected: null,
  options: [],
  disabled: false,
  className: null,
  inputId: null,
  locked: false,
};

SelectInput.propTypes = {
  inputId: PropTypes.string,
  name: PropTypes.string,
  groupName: PropTypes.string,
  className: PropTypes.string,
  selected: PropTypes.string,
  disabled: PropTypes.bool,
  locked: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    text: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  })),
};

export default SelectInput;
